interface Props<T extends string> {
  options: readonly T[];
  value: T;
  onChange: (v: T) => void;
  // The group's aria-label, e.g. "Time range" or "View".
  label: string;
}

// A row of mutually-exclusive buttons. Used for the chart range selector and
// the Trends chart/grid switch — two consumers with identical structure, so
// the markup and active styling live here rather than being duplicated.
export function SegmentedControl<T extends string>({ options, value, onChange, label }: Props<T>) {
  return (
    <div
      role="group"
      aria-label={label}
      style={{ display: 'inline-flex', gap: 'var(--sp-1)' }}
    >
      {options.map((option) => {
        const active = option === value;
        return (
          <button
            key={option}
            type="button"
            aria-pressed={active}
            onClick={() => onChange(option)}
            style={{
              fontSize: 'var(--fs-sm)',
              padding: 'var(--sp-1) var(--sp-2)',
              border: '1px solid var(--border)',
              borderRadius: 4,
              cursor: 'pointer',
              background: active ? 'var(--accent-soft)' : 'transparent',
              color: active ? 'var(--accent)' : 'var(--muted)',
              fontWeight: active ? 600 : 400,
            }}
          >
            {option}
          </button>
        );
      })}
    </div>
  );
}
